import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../home/footer";
import { gsap } from "gsap";

const eventDetailsData = {
  1: {
    title: "Sihah convecation",
    headerDesc: "Sihah Diploma in Hadees Study: Convocation Ceremony Held at Vengara",
    mainImage: "/assets/gallery/Sihah%20convecation/111.jpeg",
    bottomTitle: "Sihah convecation",
    bottomDesc1:
      "The convocation ceremony for the 'Sihah' Diploma in Hadees Study, a comprehensive 10-month program organized by Darul Hadees Islamia, was held in a grand and solemn atmosphere. Certificates were distributed to the students who successfully completed the curriculum, which was structured across two academic semesters. ​The course gained significant public attention for its in-depth modules on Hadees studies, Hubbu Nabi (Love for the Prophet ﷺ) sessions, Fiqh (Islamic Jurisprudence), and Tajweed (Quranic phonetics).",
    bottomDesc2:
      "Award Presentation: Special honors were conferred upon the top-performing student who demonstrated academic excellence across both semesters. ​Certificate Distribution: All graduates who completed the 10-month program were awarded their 'Diploma in Hadees Study' certificates. ​Umrah Award Announcement: A major highlight of the ceremony was the announcement of the Umrah and Madinah Ziara award for the student who secured the first rank in the final examinations. ​Prominent religious and social figures attended the function, offering their felicitations and inspiring the students. The event, attended by a large gathering of knowledge seekers, marked the beginning of a new chapter in systematic religious education in the region.",
    experts: [
      {
        image:
          "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.52%20PM%20(1).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.52%20PM.jpeg",
        position: "bottom",
      },
      {
        image:
          "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.53%20PM%20(1).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Sihah%20convecation/WhatsApp%20Image%202026-02-23%20at%203.29.53%20PM.jpeg",
        position: "bottom",
      },
    ],
  },
  2: {
    title: "Masjid inauguration",
    headerDesc: "Inauguration of Imam Bukhari Masjid at Darul Hadees",
    mainImage:
      "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM%20(1).jpeg",
    bottomTitle: "Masjid inauguration",
    bottomDesc1:
      "Vengara: The Imam Bukhari Masjid, situated at Darul Hadees Islamia, Gandhikunnu—Kerala's first-ever Hadees Research Centre—was officially inaugurated. The ceremony was led by E. Sulaiman Musliyar, President of Samastha Kerala Jam'iyyathul Ulama. The event was presided over by Oorakam Abdurahman Saquafi (District Secretary, Kerala Muslim Jama-at), with Sayyid Ibrahimul Khaleel Al Bukhari (State General Secretary, Muslim Jama-at) attending as the chief guest.",
    bottomDesc2:
      "Honoring Excellence: V.P.M. Faizy Villyappally, a member of the Samastha Central Mushawara, was honored during the ceremony. Distinguished Guests: Renowned scholars including Dr. Hussain Saquafi Chullikkode, Abdulla Ahsani Chengani, and Alavi Saquafi Kolathur addressed the gathering",
    experts: [
      {
        image:
          "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM.jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.54%20PM%20(1).jpeg",
        position: "bottom",
      },
      {
        image:
          "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.54%20PM.jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.55%20PM%20(1).jpeg",
        position: "bottom",
      },
    ],
  },
  3: {
    title: "Imlaa'",
    headerDesc: "Imlaa': Reviving the Tradition of Hadith Dictation and Documentation Vengara: Darul Hadees Islamia hosted a specialized session of 'Imlaa', the traditional and highly authentic method of Hadith documentation. This session aimed to revive the classical practice where students meticulously transcribe Prophetic traditions directly from the dictation of a master scholar.",
    mainImage:
      "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.17%20PM.jpeg",
    bottomTitle: "Imlaa' Gathering",
    bottomDesc1:
      "In the science of Hadith, 'Imlaa' is regarded as one of the most reliable methods of knowledge transmission, ensuring maximum accuracy and preservation of texts. As Kerala's pioneering Hadith Research Centre, Darul Hadees continues to emphasize such foundational academic traditions. Session Highlights: Direct Transmission: Eminent Hadith scholars dictated selected traditions, while students recorded them with scholarly precision.",
    bottomDesc2:
      "Isnad Verification: The session provided a deep dive into the chains of narration (Sanad), helping students understand the rigorous process of authenticating Hadith. Documentation Skills: Practical training was given on the etiquette of writing Hadith and the technical terminologies (Musthalahul Hadees) used by early traditionists. This 'Imlaa' gathering provided a unique spiritual and academic experience, bridging the gap between historical scholarship and modern-day Hadith studies at Darul Hadees Islamia.",
    experts: [
      {
        image:
          "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.18%20PM%20(1).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.18%20PM.jpeg",
        position: "bottom",
      },
      {
        image:
          "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.19%20PM%20(1).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.19%20PM.jpeg",
        position: "bottom",
      },
    ],
  },
  4: {
    title: "Hadees Seminar 2k24",
    headerDesc:
      "Hadees Seminar: A Scholarly Journey into Prophetic Traditions Vengara: Opening new doors to intellectual discourse, Darul Hadees Islamia successfully organized a high-level Hadees Seminar. The event, aimed at discussing modern challenges and solutions within the field of Hadith studies, saw active participation from prominent scholars, researchers, and students.",
    mainImage: "/assets/events/hadees seminar.jpeg",
    bottomTitle: "Hadees Seminar",
    bottomDesc1:
      "As Kerala’s first dedicated Hadees Research Centre, Darul Hadees Islamia envisioned this seminar to bridge the gap between classical Hadith sciences and contemporary academic research. Key Highlights of the Seminar: Paper Presentations: Renowned scholars presented detailed papers on the compilation of Hadith, their authenticity, and their profound relevance in the modern era. Interactive Sessions: A dedicated Q&A session allowed students and attendees to engage directly with experts, clarifying complex theological and historical aspects of Prophetic traditions.",
    bottomDesc2:
      "Research Focus: Special sessions were held on the importance of digital libraries and modern methodology in Hadith research, empowering the next generation of scholars. Leading figures from religious and cultural spheres attended the event, emphasizing the need for a scientific and disciplined approach to studying the Sunnah. This seminar marks another significant milestone in the academic journey of Darul Hadees Islamia.",
    experts: [
      { image: "/assets/events/hadees seminar_5.jpeg", position: "top" },
      { image: "/assets/events/hadees seminar_4.jpeg", position: "bottom" },
      { image: "/assets/events/hadees seminar_3.jpeg", position: "top" },
      { image: "/assets/events/hadees seminar_2.jpeg", position: "bottom" },
    ],
  },
  5: {
    title: "AL BIDAYA",
    headerDesc:
      "Partner with our team of scientists, thinkers, and industry experts to take your talent strategy to the next level. We have consulted with the world's top minds and created innovative solutions talent.",
    mainImage:
      "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.54 PM (1).jpeg",
    bottomTitle: "Hadees Seminar",
    bottomDesc1:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus cum tempora a minima reiciendis odio similique dolorum nemo esse fugit, sapiente, repellat ea eius sunt accusantium explicabo voluptatum sed obcaecati!",
    bottomDesc2:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet .",
    experts: [
      {
        image:
          "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.54 PM (2).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.55 PM.jpeg",
        position: "bottom",
      },
      {
        image:
          "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.55 PM (1).jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.55 PM (2).jpeg",
        position: "bottom",
      },
    ],
  },
  6: {
    title: "Qhathmul bukhari majlis",
    headerDesc:
      "Partner with our team of scientists, thinkers, and industry experts to take your talent strategy to the next level. We have consulted with the world's top minds and created innovative solutions talent.",
    mainImage:
      "/assets/gallery/Qhathmul bukhari majlis/4.jpeg",
    bottomTitle: "Qhathmul bukhari majlis",
    bottomDesc1:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus cum tempora a minima reiciendis odio similique dolorum nemo esse fugit, sapiente, repellat ea eius sunt accusantium explicabo voluptatum sed obcaecati!",
    bottomDesc2:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet .",
    experts: [
      {
        image:
          "/assets/gallery/Qhathmul bukhari majlis/1.jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Qhathmul bukhari majlis/2.jpeg",
        position: "bottom",
      },
      {
        image:
          "/assets/gallery/Qhathmul bukhari majlis/8.jpeg",
        position: "top",
      },
      {
        image:
          "/assets/gallery/Qhathmul bukhari majlis/7.jpeg",
        position: "bottom",
      },
    ],
  },
};

const ExpertCards = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const eventData = eventDetailsData[id] || eventDetailsData["4"];
  const experts = eventData.experts;
  const containerRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    gsap.fromTo(
      containerRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" },
    );
  }, []);

  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const openImage = (index) => {
    setSelectedImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  const navigateImages = (direction) => {
    if (selectedImageIndex !== null) {
      const newIndex =
        (selectedImageIndex + direction + experts.length) % experts.length;
      setSelectedImageIndex(newIndex);
    }
  };

  const handleKeyDown = (event) => {
    if (selectedImageIndex !== null) {
      if (event.key === "ArrowRight") {
        navigateImages(1);
      } else if (event.key === "ArrowLeft") {
        navigateImages(-1);
      } else if (event.key === "Escape") {
        closeModal();
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImageIndex]);

  const handleChange = () => {
    navigate("/gallery");
  };

  return (
    <>
      <div
        ref={containerRef}
        className="w-full max-w-7xl mx-auto px-4 relative bg-white md:mt-10 md:pt-10 mt-14 flex flex-col  "
      >
        <button
          onClick={handleChange}
          className="sm:flex hidden font-medium absolute top-7 cursor-pointer z-[45] left-2 items-center gap-2 px-3 py-2 bg-gradient-to-r from-[#263238] to-[#37474F] text-white rounded-full shadow-lg hover:from-[#37474F] hover:to-[#263238] transition-all duration-300 transform "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-arrow-left"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l14 0" />
            <path d="M5 12l6 -6" />
            <path d="M5 12l6 6" />
          </svg>
          <span className="text-sm">Back</span>
        </button>

        <div className="absolute w-52 h-52 bg-orange-400 z-30 rounded-full blur-[130px]"></div>
        {/* <div className='absolute w-52 h-52 right-10 top-0 z-30 bg-orange-400 rounded-full blur-[130px] md:block hidden'></div> */}
        <div className="absolute w-52 h-52 right-[50%] top-[40%] z-30 bg-orange-400 rounded-full blur-[120px]"></div>
        <div className="absolute w-52 h-52 right-0 top-10 z-30 bg-orange-400 rounded-full blur-[130px] md:block hidden"></div>
        <div className="absolute w-52 h-52 left-0 bottom-0 z-30 bg-orange-400 rounded-full blur-[130px]"></div>

        <div>
          <h1 className="text-center w-full font-semibold md:text-3xl text-xl py-5 pt-8 md:pt-5 relative z-40 font-AndoraModernSerif">
            {eventData.title}
          </h1>
          <p className="text-start md:text-center text-base text-black mb-12 max-w-3xl mx-auto relative z-40">
            {eventData.headerDesc}
          </p>
        </div>

        <div className="hidden md:block relative">
          <div className="grid grid-cols-4 md:px-20 gap-6 md:pt-10">
            {experts.map((expert, index) => (
              <div
                key={index}
                className={`transform z-40 relative ${expert.position === "top" ? "-translate-y-8" : "translate-y-8"}`}
              >
                <div
                  className="relative z-50 overflow-hidden rounded-lg shadow-md group cursor-pointer"
                  onClick={() => openImage(index)}
                >
                  <img
                    src={expert.image}
                    alt={`Gallery ${index + 1}`}
                    className="w-full h-64 z-50 relative object-cover transform transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute z-50 inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <p className="text-white font-semibold">View Image</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-6">
          {experts.map((expert, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg"
            >
              <img
                src={expert.image}
                alt={`Expert ${index + 1}`}
                className="w-full h-64 object-cover relative z-40"
              />
            </div>
          ))}
        </div>

        <section className="text-center md:mb-10 mb-5 flex flex-wrap gap-5 md:gap-0 z-40 md:mt-20">
          <h1 className="text-center w-full font-semibold md:text-3xl text-xl md:py-12 pt-8 md:pt-5 font-AndoraModernSerif z-40 md:block hidden">
            Our Experts are like no other
          </h1>
          <div className="md:w-1/2 w-full z-40 mt-5 md:mt-0">
            <img
              src={eventData.mainImage}
              alt="Main Event"
              className="rounded-lg w-full max-w-md mx-auto"
            />
          </div>
          <div className="md:w-1/2 w-full text-black pe-5 text-start">
            <h1 className="md:text-2xl text-xl mb-2 font-AndoraModernSerif z-40">
              {eventData.bottomTitle}
            </h1>
            <p className="z-40 md:text-base text-sm">{eventData.bottomDesc1}</p>
            <br />

            <p className="z-40 text-base">{eventData.bottomDesc2}</p>
          </div>
        </section>
      </div>

      {selectedImageIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            <button
              className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white bg-gray-800 hover:bg-gray-700 px-3 py-2 rounded-full focus:outline-none"
              onClick={() => navigateImages(-1)}
            >
              &#8592;
            </button>
            <img
              src={experts[selectedImageIndex].image}
              alt="Selected"
              className="max-w-full max-h-screen rounded-lg"
            />
            <button
              className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white bg-gray-800 hover:bg-gray-700 px-3 py-2 rounded-full focus:outline-none"
              onClick={() => navigateImages(1)}
            >
              &#8594;
            </button>
            <button
              className="absolute top-20 right-4 text-white bg-red-500 hover:bg-red-600 px-4 py-2 rounded-full focus:outline-none"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default ExpertCards;
